import graphqlClient from 'Utils/graphql-client/graphqlClient';
import { PROPOSAL_OPTION_VALIDITY } from 'Utils/request/requestDictionary';
import moment from 'moment';
import { API_DATE_FORMAT } from 'Utils/date/apiDate';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';

export type OptionValidityDuration = Array<{
  duration: number;
  minDeltaBeforeDepartureDate: number;
}>;

export const loadDurationValidity = (appContext: AppContext) => {
  const query = `
    query {
      locale {
        optionValidity {
          minDeltaBeforeDepartureDate
          duration
        }
      }
    }
  `;

  return graphqlClient.runQuery(query, appContext, {
    requestName: PROPOSAL_OPTION_VALIDITY,
  });
};

export const isBookingOptionEnabled = (appContext: AppContext): boolean =>
  isFeatureFlipped(appContext)('booking.option');

export const doesDepartureDateAllowBookingOption = (
  departureDate: string,
  minDeltaBeforeDepartureDate: number,
): boolean => {
  const todayM = moment().format(API_DATE_FORMAT);
  const departureDateM = moment(departureDate, API_DATE_FORMAT);
  const diff = departureDateM.diff(todayM, 'days');
  return diff >= minDeltaBeforeDepartureDate;
};

export const getMinimumBookingOptionMinDeltaBeforeDepartureDate = (
  optionValidityDuration: OptionValidityDuration,
): number =>
  optionValidityDuration.reduce(
    (prev, { minDeltaBeforeDepartureDate }) =>
      prev === -1 || minDeltaBeforeDepartureDate < prev ? minDeltaBeforeDepartureDate : prev,
    -1,
  );
